

import React, { useContext, useEffect, useState } from "react";
import { Typography, IconButton, Box } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { CheckCircle } from "@mui/icons-material";
// import "./viewStyle.css";
import { useDispatch } from "react-redux";
import FileContext from "../context/Context";
import { SnackbarAlert } from "../custom-component/AlertMessage";
import {
  setAlertMessageSnackbarMessageSeverity,
  setAlertMessageSnackbarMsg,
  setAlertMessageSnackbarOpen,
} from "../store/feedback";

const View = ({
  viewName,
  imageName,
  techName,
  id,
  currentStep,
  setCurrentStep,
  isCurrentStep,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const {
    capturedImages360,
    capturedChassisRC,
    capturedImageWindshield,
    isBack,
    setIsBack,
    capturedInspectionImages,
  } = useContext(FileContext);
  const [curImage, setCurImage] = useState();
  const [isCaptured, setIsCaptured] = useState(false);

  useEffect(() => {
    const foundImage = capturedInspectionImages.find(
      (image) => image.name === techName
    );
    setCurImage(foundImage);
    setIsCaptured(!!foundImage);
    if(foundImage)
    {
      setCurrentStep((prevStep) => prevStep + 1);
    }
  }, [capturedInspectionImages, techName]);

  const handleCamera = (imageName, viewName, techName) => {
    let isCaptured = capturedImages360.some((image) => image.name === techName);
    setIsCaptured(isCaptured);
    if (isCaptured) {
      let alert = {
        snackbarOpen: true,
        snackbarMessage: "Already Captured!",
        snackbarMessageSeverity: "info",
      };
      dispatch(
        setAlertMessageSnackbarMessageSeverity(alert.snackbarMessageSeverity)
      );
      dispatch(setAlertMessageSnackbarMsg(alert.snackbarMessage));
      dispatch(setAlertMessageSnackbarOpen(alert.snackbarOpen));
      setTimeout(() => {
        dispatch(setAlertMessageSnackbarOpen(false));
      }, 5000);
    } else if (isCurrentStep) {
      setIsBack((prev) => prev + 1);
      navigate("/camera", {
        state: {
          imageName: techName,
          prevPath: location?.pathname,
          id: id,
        },
      });
      setCurrentStep((prevStep) => prevStep + 1);
    } else {
      let alert = {
        snackbarOpen: true,
        snackbarMessage: "Capture in Order!",
        snackbarMessageSeverity: "info",
      };
      dispatch(
        setAlertMessageSnackbarMessageSeverity(alert.snackbarMessageSeverity)
      );
      dispatch(setAlertMessageSnackbarMsg(alert.snackbarMessage));
      dispatch(setAlertMessageSnackbarOpen(alert.snackbarOpen));
      setTimeout(() => {
        dispatch(setAlertMessageSnackbarOpen(false));
      }, 5000);
    }
  };

  return (
    <>
      <Box
        sx={{
          margin: "auto",
          marginTop: "0.2rem",
          marginBottom: "0.2rem",
          position: "relative",
          // backgroundColor: "#1a2940",
          width: "13vw",
          height: "8vw",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-evenly",
          flexDirection: "column",
          borderRadius: "5px",
          border: isCurrentStep ? "3px solid #ff0088" :isCaptured? "":"3px solid grey", 
          "@media (max-width: 1300px)": {
            width: "13vw",
            height: "8vw",
          },
          "@media screen and (max-width: 1370px) and (orientation: landscape)": {
            width: "13vw",
            height: "8vw",
          },
          "@media (max-width: 1150px)": {
            width: "13vw",
            height: "8vw",
          },
          "@media (max-width: 1060px)": {
            width: "13vw",
            height: "8vw",
          },
          "@media (max-width: 960px)": {
            width: "13vw",
            height: "8vw",
          },
          "@media (max-width: 860px)": {
            width: "13vw",
            height: "8vw",
          },
          "@media (max-width: 760px)": {
            width: "20vw",
            height: "15vw",
          },
          "@media (max-width: 650px)": {
            width: "20vw",
            height: "15vw",
          },
          "@media (max-width: 550px)": {
            width: "20vw",
            height: "15vw",
          },
          "@media (max-width: 500px)": {
            width: "20vw",
            height: "20vw",
          },
          "@media (max-width: 450px)": {
            width: "20vw",
            height: "20vw",
          },
          "@media (max-width: 400px)": {
            width: "20vw",
            height: "25vw",
          },
          "@media (max-width: 375px)": {
            width: "20vw",
            height: "25vw",
          },
          "@media (max-width: 330px)": {
            width: "20vw",
            height: "25vw",
          },
        }}
        // onClick={() => handleCamera(imageName, viewName, techName)}
      >
        {isCaptured && (
          <IconButton
            style={{
              position: "absolute",
              bottom: 0,
              right: 0,
              color: "white",
              zIndex: 1,
            }}
          >
            <CheckCircle
              sx={{
                "@media (max-width: 650px)": {
                  fontSize: "0.8rem",
                },
              }}
            />
          </IconButton>
        )}

        {!isCaptured ? (
          <>
            <img
              src={imageName}
              alt={techName}
              className="car-image"
              style={{
                width: techName==="front_left_side" || techName ==="left_side" || techName === "back_left_side" || techName === "front_right_side" || techName === "back_right_side" || techName === "right_side"?"60%":techName==="odometer"|| techName==="registrationNo"  ?"31%":techName==="RC"?"36%":techName==="front_left_tyre"||techName==="back_left_tyre"||techName==="back_right_tyre"||techName==="front_right_tyre"?"34%":techName==="selfie"?"42%":techName==="chassis"?"30%":"40%",
              }}
            />
            <Typography
              sx={{
                alignSelf: "center",
               
                // color: "#bceef5",
                // textTransform: "uppercase",
                fontSize: "0.7rem",
                paddingBottom: "0.1rem",
               "@media (max-width: 900px)and (orientation: landscape)": {
                fontSize: "0.7rem",
               },
                "@media (max-width: 700px)": {
                  fontSize: "0.7rem",
                },
                "@media (max-width: 600px)": {
                  fontSize: "0.7rem",
                },
                "@media (max-width: 470px)": {
                  fontSize: "0.7rem",
                },
                
              }}
            >
              {viewName}
            </Typography>
          </>
        ) : (
          id === 12?<div  style={{
            width: "100%",
            height:"100%",
            borderRadius: "5px",
            backgroundColor:"black"
          }}></div> : <img
            src={URL.createObjectURL(curImage.file)}
            alt="Captured"
            style={{
              width: "100%",
              height:"100%",
              borderRadius: "5px",
            }}
          />
         
        )}
      </Box>
      <SnackbarAlert />
    </>
  );
};

export default View;
